import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Ashrak Shohas',
    title: "Web Developer",
    desciption: "Let us take you into a deeper experience, make a moment a lasting conveyable memory. Let us help build your tribe. ",
    image: 'https://i.ibb.co/54gPvpk/Untitled-design-9.png',
    resumePdf: resume
}
